import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import aIbadgeIcon from "../../../assets/images/chats/aIbadgeIcon.svg";
import {
  IndicatorIcon,
  createStyledIndicatorButton,
} from "../../../common/StyledComponents/SideBarComponents";
// import {
//   handleDeleteAiHistory,
//   handleGetAiHistory,
//   handleUseHistoryQuery,
// } from "../../../appStore/actions/ArkchatGroup/action";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useAppSelectors from "../../../customHooks/useAppSelectors";
const AIAnswerBox = ({
  answerData,
  date,
  screenType,
  historyData,
  setAiQueryHistory,
  setShareAiText,
  setNewMessages,
  setSelectedAnswer,
  selecteAnswer,
  setEditModalOpen,
  handleOpenEditModal,
  queryIndx,
  isStreaming
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const BadgeButton = createStyledIndicatorButton("#F3F3F3");
  const {currentUserData} = useAppSelectors();

  const handleUseIt = () => {
    
  };

  const handleShare = (indx) => {
    if (selecteAnswer === null || selecteAnswer !== queryIndx) {
      setSelectedAnswer(indx);
      setNewMessages(answerData);
      setShareAiText(true);
    } else if (selecteAnswer === queryIndx) {
      setSelectedAnswer(null);
      setNewMessages("");
      setShareAiText(false);
    }
  };
  return (
    <Box padding="8px 0px">
      <Box display={"flex"} maxWidth={"90%"}>
        <Box mr={"0.5rem"}>
          <BadgeButton size="small" variant="contained">
            <IndicatorIcon src={aIbadgeIcon} />
          </BadgeButton>
        </Box>

        <Box width={"100%"}>
          <Typography variant="subtitle2" fontWeight={400} color={"#183242"}>
            {answerData?.split(/\n/).map((line, indx) => (
              <span
                key={line + indx}
                style={{ marginBottom: "0.5rem", display: "block" }}
              >
                {line}
              </span>
            ))}
          </Typography>

          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"baseline"}
            width={"100%"}
          >
            {screenType === "aiHistory" && (
              <Box mt={"1.5rem"}>
                <Typography>
                  {moment(date).format(currentUserData?.userDateTimeFormat)}
                </Typography>
              </Box>
            )}

            {(screenType === "aiSession"||screenType === "aiHistory") && !isStreaming && (
              <Box>
                {/* <Button
                  onClick={() => handleOpenEditModal(historyData)}
                  variant="outlined"
                  sx={{
                    mr: "0.5rem",
                    border: "1.23px solid #183242",
                    color: "#183242",
                    minHeight: "unset",
                    height: "1.7rem",
                    textTransform: "none",
                    "&:hover": {
                      border: "1.23px solid #183242",
                      color: "#183242",
                    },
                  }}
                >
                  {appContent?.KEY28}
                </Button> */}
                <Button
                  onClick={()=>handleShare(queryIndx)}
                  variant="outlined"
                  sx={{
                    border:
                      selecteAnswer === queryIndx
                        ? "1.23px solid #183243"
                        : "1.23px solid #183242",
                    background:
                      selecteAnswer === queryIndx ? "#183243" : "#fff",
                    color: selecteAnswer === queryIndx ? "#fff" : "#183242",
                    minHeight: "unset",
                    height: "1.7rem",
                    textTransform: "none",
                    "&:hover": {
                      border:
                        selecteAnswer === queryIndx
                          ? "1.23px solid #183243"
                          : "1.23px solid #183242",
                      background:
                        selecteAnswer === queryIndx ? "#183243" : "#fff",
                      color: selecteAnswer === queryIndx ? "#fff" : "#183242",
                    },
                  }}
                >
                  {appContent?.KEY29}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AIAnswerBox;
